// extracted by mini-css-extract-plugin
module.exports = {"link":"MobileMenu_link__-g-Ho"};